
import { Vue, Component, Prop } from "vue-property-decorator";
import Song from "../lib/song";

@Component
export default class SongListItem extends Vue {
  @Prop(Song) readonly song!: Song;
}
